let _sessionStorage = new Map();

let sessionStorageAvailableCache = null;

const getItemLocal = key => {
  if (!_sessionStorage.has(key)) {
    return null;
  }

  return _sessionStorage.get(key);
};

const setItemLocal = (key, value) => {
  _sessionStorage.set(key, value);
};

const isSessionStorageAvailable = () => {
  if (sessionStorageAvailableCache === null) {
    try {
      const testValue = 'SessionStorageTest';
      sessionStorage.setItem(testValue, testValue);
      sessionStorageAvailableCache = testValue === sessionStorage.getItem(testValue);
      sessionStorage.removeItem(testValue);
    } catch (e) {
      sessionStorageAvailableCache = false;
    }
  }

  return sessionStorageAvailableCache;
};

const clear = () => {
  try {
    if (isSessionStorageAvailable()) {
      sessionStorage.clear();
    }
  } finally {
    _sessionStorage = new Map();
  }
};

export const clearSessionStorageState = () => {
  sessionStorageAvailableCache = null;
  clear();
};

const getItem = key => {
  if (isSessionStorageAvailable()) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      sessionStorageAvailableCache = null;
      return getItemLocal(key);
    }
  }

  return getItemLocal(key);
};

const setItem = (key, value) => {
  if (isSessionStorageAvailable()) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      sessionStorageAvailableCache = null;
    }
  }

  setItemLocal(key, value);
};

export default {
  getItem,
  setItem,
  clear
};